import {
    GET_VEHICLE_LIST,GET_DRIVER,GEt_STUDENT_LIST, STUDENT_ASSIGN_VEHICLE, VEHICLE_STUDENTS_LIST, STUDENTS_LIST_DATA, VEHICLE_ACTIVE, VEHICLE_DEACTIVE
  } from '../actions/VehicleActions';
  
  const initialState = {// initialize states
    vehicle: [],
    driver:[],
    vehicle_students:[],
    Students:[],
  };
  
  const VehicleReducer = function (state = initialState, action) {
    switch (action.type) {
      case GET_VEHICLE_LIST: {// save vehicle data into state
        return { ...state, vehicle: (action.payload.data)?action.payload.data:[] };
      }
      case GET_DRIVER: { // save driver data into state
        return { ...state, driver: (action.payload.data)?action.payload.data:[] };
      }
      case STUDENT_ASSIGN_VEHICLE: {
        return { ...state };
      }
      case VEHICLE_ACTIVE: {
        return { ...state };
      }
      case VEHICLE_DEACTIVE: {
        return { ...state };
      }
      case VEHICLE_STUDENTS_LIST: { // save vehicle student data into state
        return { ...state, vehicle_students: (action.payload.data)?action.payload.data:[] };
      }
      case STUDENTS_LIST_DATA: { // save students data into state
        return { ...state, Students: (action.payload.data)?action.payload.data:[] };
      }
      default: {
        return {
          ...state,
        };
      }
    }
  };
  
  export default VehicleReducer;
  